import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LineupPremiereComponent } from '../spotlight/lineup/lineup-premiere/lineup-premiere.component';
import { SpotlightComponent } from './components/spotlight/spotlight.component';
import { UpcomingPremiereComponent } from '../spotlight/upcoming/upcoming-premiere/upcoming-premiere.component';
import { MoreInfoComponent } from './premiere-details/more-info/more-info.component';
import { PremiereDetailsModule } from './premiere-details/premiere-details.module';
import { SpotlightRootComponent } from './components/spotlight-root/spotlight-root.component';
const routes: Routes = [
  {
    path: '',
    component: SpotlightComponent,
    children: [
      {
        path: 'upcoming',
        component: UpcomingPremiereComponent,
      },
      {
        path: 'lineup',
        component: LineupPremiereComponent,
      },
      {
        path: 'archive',
        component: LineupPremiereComponent,
      },
      {
        path: 'more-info/:id/:premiere-name',
        component: MoreInfoComponent,
      }
    ]
  },
  

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SpotlightRoutingModule { }
